const release = '0.13.7'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js